import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const giftApi = createApi({
  reducerPath: 'giftApi',
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_SERVER_HOST,
    prepareHeaders: headers => {
      const accessToken = localStorage.getItem('access-token');
      const pubId = localStorage.getItem('pub_id');

      if (accessToken) headers.set('access-token', accessToken);
      if (pubId) headers.set('pubid', pubId);

      return headers;
    }
  }),
  tagTypes: ['GiftTransactions'],
  endpoints: builder => ({
    getUserGiftTransactions: builder.query({
      query: ({ pubId, selectedUserId, filters = {} } = {}) => {
        const params = {
          pubid: pubId
        };

        if (filters.start_date) params.start_date = filters.start_date;
        if (filters.end_date) params.end_date = filters.end_date;
        if (filters.status) params.status = filters.status;
        if (filters.plan_id) params.plan_id = filters.plan_id;
        if (selectedUserId) params.user_id = selectedUserId;

        return {
          url: '/report/giftTransactions',
          params
        };
      },
      providesTags: ['GiftTransactions']
    }),

    claimGift: builder.mutation({
      query: ({ selectedUserId, giftCode }) => {
        const body = {
          uid: selectedUserId,
          giftcode: giftCode
        };

        return {
          url: '/user/subscription/redeem',
          method: 'POST',
          body,
        };
      },
      invalidatesTags: (result, error) => {
        if (error) return [];
        if (result?.success === false) return [];

        return ['GiftTransactions'];
      }
    })
  })
});

export const { useGetUserGiftTransactionsQuery, useClaimGiftMutation } = giftApi;